export default __webpack_public_path__ + "static/media/mat-man-wdt.0818c434.png";